export enum LeaseTermUnits {
  Days = 'Days',
  Months = 'Months',
  Years = 'Years',
  Unknown = 'Unknown',
}
